<template>
  <div class="v3-popup lottery-succ-popup">
    <div class="v3-popup-mask" @click="handleClose"></div>
    <div
      class="v3-popup-content"
      :class="{
        large: lotteryResult.length > 1,
        succ: lotteryResult.length == 1,
      }"
    >
      <div class="v3-popup-content-close" @click="handleClose"></div>
      <div class="v3-popup-content-title">{{ isThanksOnly ? langData.tipPopupTitle : langData.lotterySuccTitle }}</div>
      <div class="v3-popup-content-content">
        <div class="lottery-result-list">
          <div
            class="lottery-result-item"
            v-for="(item, index) in lotteryResult"
            :key="`${item.awardVtId}-${index}`"
          >
            <div class="award-icon-box">
              <div class="award-icon" :class="[`award-${item.awardId}`, curLang]"></div>
            </div>
            <div class="lottery-result-item-title">
              {{ langData[awardConfig[item.awardId]] || item.awardName }}
            </div>
          </div>
        </div>
      </div>
      <div class="v3-popup-content-footer">
        <div class="confirm-btn btns" @click="handleClose">{{ langData.confirmBtn }}</div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { inject, ref, computed } from "vue";

import LanguageHook from "@hooks/language";
import { awardConfig } from "@/config";
// 语言相关
const { langData, curLang } = LanguageHook();

const v3PopupState = inject("v3PopupState");
const lotteryResult = inject("lotteryResult", ref([]));

const isThanksOnly = computed(() =>
  lotteryResult.value.length > 0 && lotteryResult.value.every(item => item.awardId === "Thanks")
);

const handleClose = () => {
  v3PopupState.lotterySuccPopupState = false;
  lotteryResult.value = [];
};
</script>

<style scoped lang="less"></style>
